// wayPickBus.ts
// =============
//
// Wave 14ca-fix64: Way-ID-Pick-Mode (Discovery-Override-Workflow).
//
// Der Admin moechte unterwegs einen Tap-Modus haben in dem er auf einen
// beliebigen Punkt der Karte tippt und dann die OSM way_id + Laenge des
// nachstgelegenen Weges sieht — mit Buttons "Add to discovery overrides
// (block / approve / one-way)" und "Dismiss".
//
// Pattern: das WAY-ID-Button sitzt in DiscoveryButtons (innerhalb MapPage),
// der Pick-Mode-State + die Logik (Click-Handler, Modal, Border) sitzen in
// MapPage. Damit das Button-Komponent die Mode-Aktivierung triggern kann
// ohne MapPage-Props durchzureichen, kommunizieren wir ueber diesen Bus.
//
// Activate vs Deactivate:
//   - DiscoveryButtons.WAY-ID-Tap → wayPickBus.activate()
//   - MapPage subscribed, setzt isPickMode=true, blendet orange Border ein
//   - User tippt auf Karte → MapPage snappt + zeigt Modal
//   - Modal "Dismiss" → wayPickBus.deactivate()
//   - Modal "Add" → POST → optional: bleibt im Pick-Mode für naechsten Tap

type Listener = (active: boolean) => void;

class WayPickBus {
  private active = false;
  private readonly listeners = new Set<Listener>();

  get(): boolean {
    return this.active;
  }

  activate(): void {
    if (this.active) return;
    this.active = true;
    this.notify();
  }

  deactivate(): void {
    if (!this.active) return;
    this.active = false;
    this.notify();
  }

  toggle(): void {
    this.active = !this.active;
    this.notify();
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  private notify(): void {
    for (const l of this.listeners) l(this.active);
  }
}

export const wayPickBus = new WayPickBus();
